import { PageHeaderProvider } from "@/providers/PageHeaderProvider";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/planning/contact-information",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Kontaktinformationer",
    },
  },
});

function RouteComponent() {
  return (
    <PageHeaderProvider options={{ title: "Kontaktinformationer" }}>
      <Outlet />
    </PageHeaderProvider>
  );
}
